import React from 'react';

const getSortHeaderProps = (sorted = []) => {
  return {
    Header: props => {
      const sortInfo = sorted.filter(
        item => item.id === props.column.id
      );
      let icon = '';
      if (sortInfo.length) {

        if (sortInfo[0].desc) {
          icon = 'fa fa-caret-down';
        } else {
          icon = 'fa fa-caret-up';
        }
      }

      return (
        <span>
          {props.column.headerText}
          {icon && <i className={icon} />}
        </span>
      );
    },
  };
};

export default getSortHeaderProps;
